import { useQuery } from '@tanstack/react-query';
import { getCountryRisk, getCountryForecast } from '../api/client';

export type ForecastHorizon = 'today' | '24h';

export function useCountryRisk(runId?: string, horizon: ForecastHorizon = 'today') {
  return useQuery({
    queryKey: ['countryRisk', runId, horizon],
    queryFn: () =>
      horizon === '24h'
        ? getCountryForecast(24)
        : getCountryRisk(undefined, runId),
    staleTime: 3 * 60 * 60 * 1000, // 3 hours
    refetchInterval: 3 * 60 * 60 * 1000, // auto-refetch every 3h
    retry: 2,
  });
}
